(function () {
  function initImageCarousel(sectionEl) {
    if (!sectionEl) return;
    var track = sectionEl.querySelector('[data-image-carousel]');
    if (!track || track.dataset.flickityInitialized === 'true') return;

    if (typeof window.Flickity !== 'function') {
      setTimeout(function () { initImageCarousel(sectionEl); }, 100);
      return;
    }

    var flkty = new window.Flickity(track, {
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      autoPlay: 2000,
      pauseAutoPlayOnHover: false,
      prevNextButtons: true,
      pageDots: false,
      draggable: true,
      groupCells: 1,
      imagesLoaded: true,
      accessibility: true
    });

    if (typeof flkty.playPlayer === 'function') {
      flkty.playPlayer();
    }

    // Manual hover pause/resume — more reliable than Flickity's built-in
    // pauseAutoPlayOnHover, which can miss mouseleave on arrow buttons / cells.
    sectionEl.addEventListener('mouseenter', function () {
      if (typeof flkty.pausePlayer === 'function') flkty.pausePlayer();
    });
    sectionEl.addEventListener('mouseleave', function () {
      if (typeof flkty.unpausePlayer === 'function') flkty.unpausePlayer();
      if (typeof flkty.playPlayer === 'function') flkty.playPlayer();
    });

    // Re-trigger sizing + autoplay once images finish loading.
    var imgs = track.querySelectorAll('img');
    imgs.forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        flkty.resize();
        if (typeof flkty.playPlayer === 'function') flkty.playPlayer();
      }, { once: true });
    });

    track.dataset.flickityInitialized = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="image-carousel-section"]').forEach(initImageCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sectionEl = event.target.querySelector('[data-section-type="image-carousel-section"]');
    if (sectionEl) initImageCarousel(sectionEl);
  });
})();
